import { render, staticRenderFns } from "./VerticalClinicalWorkspace.vue?vue&type=template&id=1dbf6e36&scoped=true"
import script from "./VerticalClinicalWorkspace.vue?vue&type=script&lang=js"
export * from "./VerticalClinicalWorkspace.vue?vue&type=script&lang=js"
import style0 from "./VerticalClinicalWorkspace.vue?vue&type=style&index=0&id=1dbf6e36&prod&scoped=true&lang=css"
import style1 from "./VerticalClinicalWorkspace.vue?vue&type=style&index=1&id=1dbf6e36&prod&scoped=true&lang=css"
import style2 from "./VerticalClinicalWorkspace.vue?vue&type=style&index=2&id=1dbf6e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbf6e36",
  null
  
)

export default component.exports